import { DAILY_SUMMARY } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const dailySummaryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDailySummaries: build.query({
      query: (params = {}) => ({
        url: DAILY_SUMMARY.LIST,
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('DailySummary', result),
    }),
    getDailySummaryById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: DAILY_SUMMARY.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: 'DailySummary',
          id: typeof arg === 'object' && arg != null ? arg.id : arg,
        },
      ],
    }),
    createDailySummary: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: DAILY_SUMMARY.CREATE,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'DailySummary', id: 'LIST' }],
    }),
    updateDailySummary: build.mutation({
      query: ({ id, data: updateData, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: DAILY_SUMMARY.BY_ID(id),
          method: 'PUT',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'DailySummary', id },
        { type: 'DailySummary', id: 'LIST' },
      ],
    }),
    deleteDailySummary: build.mutation({
      query: (id) => ({ url: DAILY_SUMMARY.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'DailySummary', id },
        { type: 'DailySummary', id: 'LIST' },
      ],
    }),
    importDailySummary: build.mutation({
      query: (formData) => ({
        url: DAILY_SUMMARY.IMPORT,
        method: 'POST',
        data: formData,
        ...multipart,
      }),
      invalidatesTags: [{ type: 'DailySummary', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetDailySummariesQuery,
  useLazyGetDailySummariesQuery,
  useGetDailySummaryByIdQuery,
  useLazyGetDailySummaryByIdQuery,
  useCreateDailySummaryMutation,
  useUpdateDailySummaryMutation,
  useDeleteDailySummaryMutation,
  useImportDailySummaryMutation,
} = dailySummaryApi;
